import { Box, Typography, Paper, Chip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const SYSTEM_STATUS = [
  { label: 'MongoDB', status: true },
  { label: 'SVG Pipeline', status: true },
  { label: 'Socket.IO', status: true },
  { label: 'Google OAuth', status: !!process.env.REACT_APP_GOOGLE_CLIENT_ID },
];

export default function GeneralSettings() {
  return (
    <Box>
      <Typography sx={{ fontWeight: 700, fontSize: 16, mb: 2 }}>System Status</Typography>
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 3 }}>
        {SYSTEM_STATUS.map(s => (
          <Chip key={s.label} icon={<CheckCircleIcon sx={{ fontSize: 14 }} />}
            label={s.label} size="small"
            sx={{ background: s.status ? '#f0fdf4' : '#fef2f2', color: s.status ? '#22c55e' : '#ef4444', fontWeight: 600 }} />
        ))}
      </Box>

      <Typography sx={{ fontWeight: 700, fontSize: 16, mb: 1 }}>Service Configuration</Typography>
      <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, fontSize: 13 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <span style={{ color: '#888' }}>Google OAuth</span>
            <span style={{ fontFamily: 'monospace', fontSize: 11 }}>
              {process.env.REACT_APP_GOOGLE_CLIENT_ID ? '...connected' : 'Not configured'}
            </span>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <span style={{ color: '#888' }}>Monthly Rate</span>
            <span style={{ fontWeight: 600 }}>$75 / store</span>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <span style={{ color: '#888' }}>Setup Fee</span>
            <span style={{ fontWeight: 600 }}>$300</span>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <span style={{ color: '#888' }}>SVG Renderer</span>
            <span style={{ fontWeight: 600 }}>Puppeteer (1922x1080)</span>
          </Box>
        </Box>
      </Paper>

      <Typography sx={{ fontWeight: 700, fontSize: 16, mb: 1, mt: 3 }}>About</Typography>
      <Typography sx={{ fontSize: 13, color: '#888' }}>
        Digntec Signage CMS v2.0 — Digital Menu Board Management System
      </Typography>
    </Box>
  );
}
